module.exports = __webpack_public_path__ + "img/totalRevenueSecond.49aeb708.svg";